import { useCallback } from "react";
function useActions(index, onDelete, onChange, onSwapItems) {
  const deleteItem = useCallback(() => {
    onDelete(index);
  }, [index, onDelete]);
  const changeItem = useCallback(
    (value) => {
      onChange(index, value);
    },
    [index, onChange]
  );
  const moveUp = useCallback(() => {
    onSwapItems?.(index, index - 1);
  }, [index, onSwapItems]);
  const moveDown = useCallback(() => {
    onSwapItems?.(index, index + 1);
  }, [index, onSwapItems]);
  return { deleteItem, moveUp, moveDown, changeItem };
}
export {
  useActions
};
//# sourceMappingURL=useActions.js.map
